/**
 * Created by 丸子 on 2018/7/19 0019.
 */
const namespace = 'session/'

export const GETTERS = {
  userInfo: namespace + 'userInfo',
  isLogged: namespace + 'isLogged',
  menus: namespace + 'menus'
}

export const ACTIONS = {
  fetchUserInfo: namespace + 'fetchUserInfo',
  logout: namespace + 'logout',
  login: namespace + 'login',
  getTree: namespace + 'getTree',
  checkToken: namespace + 'checkToken'
}

export const MUTATIONS = {
  setUserInfo: namespace + 'setUserInfo',
  setMenus: namespace + 'setMenus',
  setToken: namespace + 'setToken'
}